export enum AppPath {
  ROOT = '',
  LOGIN = 'login',
  LOGINFA = 'login/FusionAuth',
  LOGOUT = 'logout',
  ACCUEIL = 'accueil',
  NON_AUTORISE = 'nonAutorise',
  PROFILS_DROITS = 'profils-droits',
  UTILISATEURS = 'utilisateurs',
  PERSONNES = 'personnes',
  FORMATEURS = 'formateurs',
  INSCRIPTION = 'inscriptions',
  INSCRIPTIONS_FORMATION = 'inscriptions-formation',
  INSCRIPTIONS_PARCOURS = 'inscriptions-parcours',
  ENTITES = 'entites',
  PARAMETRES = 'parametres',
  FORMATIONS = 'formations',
  SESSIONS = 'sessions',
  SEANCES = 'seances',
  PLANNING_FORMATEURS = 'planning-formateurs',
  ERREUR404 = '404',
  ENTREPRISES = 'entreprises',
  PERSONNELS = 'personnels',
  ARTICLES = 'articles',
  PUBLIPOSTAGE_MODELES = 'publipostage-modeles',
  EVALUATIONS = 'evaluations',
  DEMO = 'demo',
  DOSSIERS_FINANCEMENT = 'dossiers-financement',
  FACTURATION = 'facturation',
  FACTURATION_TRAITEMENT = 'facturation-traitement',
  AVOIR = 'avoir',
  MATIERES = 'matieres',
  TACHES = 'taches',
  AGENDA_TACHES = 'agenda-taches',
  CONNECTEURS = 'connecteurs',
  IMPORTS = 'imports',
  BPF = 'export-bpf',
  STATISTIQUES = 'statistiques',
  TARIFS= 'tarifs',
  RESSOURCES = 'ressources',
  PARCOURS = 'parcours',
  COMPTABILITE = 'comptabilité',
  PLANNING_RESSOURCES = 'planning-ressources',
  E_PROCESS = 'automatisations',
  E_PROCESS_CREATE = 'create',
  E_PROCESS_EDIT = 'edition',
}
